import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { ReactComponent as SearchIcon } from '../../icons/search.svg';
import { ReactComponent as CloseIcon } from '../../icons/xmark-circle.svg';
import { ReactComponent as ArrowUpIcon } from '../../icons/arrow-up.svg';
import { ReactComponent as XmarkIcon } from '../../icons/xmark.svg';

import './SearchBox.scss';

// bar: the app-bar pill. count shows while typing; onRestore swaps the search icon for an up arrow
const SearchBox = ({
  value,
  label,
  onChange,
  onClearInput,
  isMainSearchBox,
  hideServices,
  autoFocus,
  bar,
  count,
  onRestore,
  trailing,
}) => {
  const { t } = useTranslation();
  const inputRef = useRef();

  // preventScroll, so a box mounting inside a sliding sheet doesn't yank the sheet mid-animation
  useEffect(() => {
    if (autoFocus) inputRef.current?.focus({ preventScroll: true });
  }, [autoFocus]);

  function renderIcon() {
    if (value.length > 0)
      return (
        <span onClick={clearInput} className="clickable search-clear-btn">
          <Icon icon={<CloseIcon />} />
        </span>
      );
    else
      return (
        <span>
          <Icon icon={<SearchIcon />} />
        </span>
      );
  }

  function clearInput() {
    onClearInput();
    inputRef.current.focus();
  }

  function handleMainSearchBoxClick() {
    if (isMainSearchBox && window.innerWidth < 992) {
      hideServices(true);

      const timerId = setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        clearTimeout(timerId);
      }, 500);
    }
  }

  function handleRestore(e) {
    // The wrapper's click would hide what this just brought back
    e.stopPropagation();
    onRestore();
  }

  // Built like the app bar: what's typed sits between a leading icon and the caller's own buttons
  if (bar)
    return (
      <div className="SearchBox is-bar" onClick={handleMainSearchBoxClick}>
        {onRestore ? (
          <button type="button" className="restore" aria-label={t('search.showServices')} onClick={handleRestore}>
            <Icon icon={<ArrowUpIcon />} />
          </button>
        ) : (
          <span className="lead">
            <Icon icon={<SearchIcon />} />
          </span>
        )}
        <input
          ref={inputRef}
          type="text"
          name="query"
          value={value}
          className="search-box"
          placeholder={label}
          aria-label={label}
          onChange={(e) => onChange(e.currentTarget.value)}
        />
        {value.length > 0 && (
          <>
            {count && <span className="count">{count}</span>}
            <button type="button" className="clear" aria-label={t('search.clear')} onClick={clearInput}>
              <Icon icon={<XmarkIcon />} />
            </button>
          </>
        )}
        {trailing}
      </div>
    );

  return (
    <div className="SearchBox" onClick={handleMainSearchBoxClick}>
      <input
        ref={inputRef}
        type="text"
        name="query"
        value={value}
        className="mg-form-control search-box"
        placeholder={label}
        onChange={(e) => onChange(e.currentTarget.value)}
      />
      {renderIcon()}
    </div>
  );
};

export default SearchBox;
